import { render, staticRenderFns } from "./SchoolListSectionForm.vue?vue&type=template&id=1cf0a998"
import script from "./SchoolListSectionForm.vue?vue&type=script&lang=js"
export * from "./SchoolListSectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports